// @ts-ignore
import {ReCaptchaV2} from 'grecaptcha';

let promise: Promise<ReCaptchaV2>;

export function getRecaptcha(): Promise<ReCaptchaV2> {
	if (!promise) promise = loadRecaptcha();
	return promise;
}

function loadRecaptcha(): Promise<ReCaptchaV2> {
	return new Promise(resolve => {
		// @ts-ignore explicit
		window.recaptchaCallback = () => {
			// @ts-ignore
			delete window.recaptchaCallback;
			resolve(window.grecaptcha);
		};

		const script = document.createElement('script');
		script.async = true;
		script.defer = true;
		script.src = 'https://www.google.com/recaptcha/api.js?onload=recaptchaCallback&render=explicit';
		document.body.appendChild(script);
	});
}
